export default "__VITE_ASSET__2e9dbc70__"